import suggest from './suggest';
import reset from './reset';

export default {
  suggest,
  reset,
};
